import React from 'react';

export default function Students() {
  // const auth = getAuth();
  // const navigate = useNavigate();
  // onAuthStateChanged(auth, (user) => {
  //   if (user) {
  //     setCurUser(user);
  //     // ...
  //   } else {
  //     navigate('/login');
  //   }
  // });
  return <div />;
}
